<template>
    <div class="workflow-template fh">
      <div class="setting-header v-center space-between px-3">
        <div class="setting-heading-box">
          <img class="btn-icon setting-icon" src="~@/assets/images/icons/workflow-icon.svg" alt="" width="15px" />
        <h1 class="setting-name">
          Workflow Templates
        </h1>
        <p class="setting-subscript">Tenant-defined workflows governing process execution</p>
        </div>
        <div class="v-center">
            <div>
            <label for="">Sort By</label>
            <select v-model="selectedSort" @change="getTemplateData(pageNo)" class="workflow-template-bar-sort" name="" id="">
              <option value="1">Latest</option>
              <option value="2">Oldest</option>
              <option value="3">Sort: A to Z</option>
              <option value="4">Sort: Z to A</option>
            </select>
          </div>
          <div class="input-group search m mx-3">
            <input
              @input="updateSearchKeyword"
              :value="searchKeywordWf"
              type="text"
              placeholder="Search by name"
            />
          </div>
            <button class="btn" v-if="showCreateAction" @click="openModal=true">+ Add Template</button>
        </div>
      </div>
      <div class="workflow-template-container pt-2">
        <div class="fh center" v-if="loading">
          <loading-circle />
        </div>
        <div
          class="workflow-template-no-form fh center"
          v-if="!loading && tempalateData.length === 0"
        >
          No Workflow Templates
        </div>
        <div class="copy-dtx-table workflow-template-table" v-if="!loading && tempalateData.length">
    <table >
        <thead>
      <tr class="m">
        <th>Name</th>
        <th>Created</th>
        <th>Type</th>
        <th>Form Template</th>
        <th>Linked feature</th>
      </tr>
    </thead>
      <tbody>
        <tr class="s" v-for="item in tempalateData" :key="item.id" @click="
                        $router.push(
                          `/workflows/${item.type_value?.name}/?tid=${item.id}`
                        )">
        <td class="elipsis-text " v-overflow-tooltip>
            {{ item?.name }}
        </td>
        <td class="audit-cell">
          <span class="audit-name" v-overflow-tooltip>{{  getFullName(item.created_by_user) }}</span>
          <span class="audit-date">{{ item.created_on | genericFormatDate }}</span>
        </td>
        <td>{{item.type_value?.name}}</td>
        <td>

<div class="workflow-template-linkedTemmplates" >
{{item.core_form_template.length ?? '--'}}
</div>
        </td>
        <td>{{ featureMapping[item.feature_id] }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="space-between">
          <pagination
          :length="totalCount"
          :perPage="perPage"
          :pageNumber="currentPageNo"
          @selectPage="pageSelected"
          class="mt-3 mx-2"
      ></pagination>
      <span class="mt-5">Total Workflow templates : &nbsp; <b class="mr-5"> {{ totalCount }}</b></span>
  </div>

      </div>
      <modal
      :open="openModal"
      @close="openModal=false"
      :closeOnOutsideClick="true"
      title="Select Workflow Type">
      <div class="workflow-type-modal">
          <RouterLink to="/workflows/NORMAL">
          <div  class="center workflow-type-modal-item" >
            <img src="~@/assets/images/icons/inherit-icon.svg" alt="" />
            <div>Quick Flow</div>
          </div>
      </RouterLink>
          <RouterLink to="/workflows/FULL">
          <div class="center workflow-type-modal-item">
            <img src="~@/assets/images/icons/add-icon.svg" alt="" />
            <div>Custom Flow</div>
          </div>
      </RouterLink>
        </div>
      </modal>
    </div>
  </template>
<script>
import { getAllWorkFLowTemplatesWithPagination } from '@/api'
import { genericFormatDate } from '@/utils/date'
import loadingCircle from '@/components/common/loadingCircle.vue'
import { timeStampToDateTime } from '@/filters/dateFilter.js'
import Modal from '@/components/common/modal.vue'
import Pagination from '@/components/common/pagination2.vue'
import { debounce } from '@/utils/debounce'
import { mapGetters, mapMutations } from 'vuex'
import config from '@/config'
// import { alert, success } from '@/plugins/notification'
export default {
  components: { loadingCircle, Modal, Pagination },
  name: 'work-flow-template',
  beforeRouteEnter (to, from, next) {
    if (!from.fullPath.includes('workflows')) {
      next(vm => {
        vm.clearSearchKeywordWf()
      })
    } else {
      next()
    }
  },
  filters: {
    timeStampToDateTime,
    genericFormatDate
  },
  data: () => ({
    tempalateData: [],
    loading: false,
    openModal: false,
    totalCount: 0,
    perPage: 20,
    currentPageNo: 1,
    window: window,
    updateOnSearch: null,
    selectedSort: 1,
    featureMapping: config.CORE_FEATURES_INVERTED
  }),
  methods: {
    ...mapMutations('workflow', ['setSearchKeywordWf', 'clearSearchKeywordWf']),
    getTemplateData (pageNo = 1) {
      this.loading = true
      const height = this.window.innerHeight
      this.perPage = Math.floor((height - 283 - 10) / 62)
      getAllWorkFLowTemplatesWithPagination(this.perPage, pageNo, this.searchKeywordWf, 'tenant', this.selectedSort).then((res) => {
        this.tempalateData = res.workflow_templates
        this.totalCount = res.workflow_templates_aggregate.aggregate.count
        this.currentPageNo = pageNo
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    getFullName (user) {
      if (user) { return `${user.first_name} ${user.last_name}` }
      return ''
    },
    pageSelected (pageNo) {
      this.$router.push(`/settings/copy-workflows/${pageNo}`)
    },
    updateSearchKeyword (el) {
      this.updateOnSearch()
      this.setSearchKeywordWf({ keyword: el.target.value })
    }

  },
  computed: {
    ...mapGetters(['user', 'isOnProjectLevel']),
    ...mapGetters('workflow', ['searchKeywordWf']),
    showCreateAction () {
      if (this.user.tenantLevelRole === 'ADMIN') {
        return true
      }
      return false
    }
  },
  created () {
    this.updateOnSearch = debounce(() => {
      this.getTemplateData(1)
    }, 500)
  },
  beforeDestroy () {
    this.updateOnSearch = null
  },
  mounted () {
    this.currentPageNo = parseInt(this.$route?.params?.pageNo)
    this.getTemplateData(this.currentPageNo)
  },
  watch: {
    '$route.params.pageNo' (newNo, oldNo) {
      if (newNo !== oldNo) {
        this.getTemplateData(parseInt(newNo))
      }
    }
  }
}

</script>
  <style lang="scss" scoped>
      .audit-cell {
    white-space: normal !important;
    line-height: 1.2;
  }
  .audit-name,
  .audit-date {
   display: block;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
  }
  .audit-name {
   font-size: var(--text-xs2);
   font-weight: 400;
   color: #111827;
  }
  .audit-date {
   margin-top: 4px;
   font-size: var(--text-xs);
   color: #6b7280;
  }
  .workflow {
      &-type{
      &-modal{
          width: 640px;
      padding: 60px 20px;
      background-color: var(--bg-color);
      background: rgba(var(--brand-rgb), 0.3);
      display: flex;
      justify-content: space-around;
      &-item  {
        width: 160px;
        height: 160px;
        font-size: var(--text-l);
        background: var(--bg-color);
        border-radius: 8px;
        flex-direction: column;
        color: black;
        row-gap: 10px;
        &:hover {
          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
        }
      }
      }
  }
  &-template {
    &-table {
      height: calc(100% - 60px);
    }
    &-bar {
      height: 60px;
      margin-bottom: 0;
      background: var(--bg-color);
      border-bottom: var(--border);
      &-sort {
    height: 2em;
    width: 10rem;
    margin: 0 5px 0 5px;
    // margin-left: 2px;
    font-size: var(--text-base);
    background-color: var(--brand-light-color);
    line-height: 1;
    border: 1px solid var(--brand-color);
    border-radius: 4px;
    padding: 4px 12px;
    }
    }
    &-container {
      height: calc(100% - 60px);
    }
    &-no-form {
      font-size: var(--text-2xl);
      color: var(--text-color);
    }
    &-group {
      overflow: auto;
      position: relative;
      & > div {
        & > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          & > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        }
      }
      &-header {
        background-color: var(--brand-color);
        position: sticky;
        top: 0;
        &-item {
          padding: 4px 10px;
          font-size: var(--text-base);
          font-weight: 600;
          color: var(--text-color);
        }
      }
      &-row {
        display: grid;
        grid-template-columns: 2fr 3fr 1fr 1fr 80px;
      }
      &-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        & > div {
          padding: 4px 10px;
          font-size: var(--text-base);
          color: var(--text-color);
        }
      }
    }
&-linkedTemmplates{
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--brand-light-color);
width: 3rem;
height: 3rem;
  border-radius: 50%;
  color: var(--text-color);
  font-size: var(--text-base);
  font-weight: 500;
}
  }
  }
  .copy-dtx-table{
  max-height: none;
}
  </style>
